<template>
  <fragment>
    <default-header
        v-if="currentClient"
        :h2="`${currentClient.first_name} ${currentClient.last_name}`"
    ></default-header>

    <PhoneNumberModal v-if="showPhoneNumberModal" @send="resendSms" @close="closeModal"/>

    <div class="innerContent">
      <back-btn></back-btn>
      <div v-if="!currentClientLoadingStatus && currentClient">
        <h4 v-if="currentClient.quote" class="form-title mb-3">{{$t('clientDetails.yourProposal')}}</h4>

        <div v-if="currentClient.quote && (currentClient.quote.status === 0)">
          <div class="additionalPadding">

            <div class="clientDetails__message"
                 v-if="(currentClient.quote.sms_status == 'delivered') || quoteSmsStatus == 'delivered' "

            >
              <div class="clientDetails__message__triangle"></div>
              <div class="clientDetails__message__date">{{ currentClient.quote.updated_at }}</div>
              <div class="clientDetails__message__msg"
              >{{ $t('clientDetails.clientDidntRespondYet')}}
              </div>
            </div>

            <div v-else-if="quoteSmsHash">{{ smsStatusTranslation(quoteSmsStatus) }}</div>

            <div v-else>
              <template v-if="currentClient.quote.sms_status == 'sent'">
                {{ $t('smsStatus.sending')}}
              </template>

              <template v-else>
                {{ $t('smsStatus.failed')}}
              </template>
            </div>

            <button class="btn btn-primary btn-block mt-4 mb-2" @click.prevent="sendQuote">{{$t('smsStatus.sendAgain')}}</button>

            <div v-for="(battery, index) in currentClient.quote.batteries">
              <h3 class="text-center mt-4 mb-1">{{$t('clientDetails.proposedBattery')}} #{{index+1}}</h3>
              <div v-if="battery.manufacturer" class="clientDetailsRow">
                <span class="clientDetailsRow__text">{{$t('clientDetails.brand')}}</span>
                <span class="clientDetailsRow__text">{{ battery.manufacturer }}</span>
              </div>
              <div v-if="battery.model" class="clientDetailsRow">
                <span class="clientDetailsRow__text">{{$t('report.model')}}</span>
                <span class="clientDetailsRow__text">{{ battery.model }}</span>
              </div>
              <div v-if="battery.part" class="clientDetailsRow">
                <span class="clientDetailsRow__text">{{$t('report.part')}}</span>
                <span class="clientDetailsRow__text">{{ battery.part }}</span>
              </div>
              <div v-if="battery.parameters && battery.parameters.cca" class="clientDetailsRow">
                <span class="clientDetailsRow__text">{{$t('report.cca')}}</span>
                <span class="clientDetailsRow__text">{{ battery.parameters.cca + ' Ah' }}</span>
              </div>
              <div
                  v-if="battery.parameters && battery.parameters.capacity"
                  class="clientDetailsRow"
              >
                <span class="clientDetailsRow__text">{{$t('report.capacity')}}</span>
                <span class="clientDetailsRow__text">{{ battery.parameters.capacity }}</span>
              </div>
              <div
                  v-if="battery.battery_price >= 0 && battery.service_price >= 0"
                  class="clientDetailsRow mb-2"
              >
                <span class="clientDetailsRow__text">{{$t('general.PriceBattery')}}</span>
                <span
                    class="clientDetailsRow__text"
                >{{battery.battery_price }}{{currentClient.currency.label}}</span>
              </div>
              <div
                  v-if="battery.battery_price >= 0 && battery.service_price >= 0"
                  class="clientDetailsRow mb-2"
              >
                <span class="clientDetailsRow__text">{{$t('quote.PriceService')}}</span>
                <span
                    class="clientDetailsRow__text"
                >{{battery.service_price}}{{currentClient.currency.label}}</span>
              </div>
              <div class="clientDetailsRow__comment mb-3" v-if="battery.comment">
                <h3 class="text-center mt-2 mb-1">{{$t('clientDetails.comment')}}:</h3>
                <div class="pl-3 pr-3">
                  <i>
                    <span class="clientDetailsRow__comment__text">{{battery.comment}}</span>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
            v-if="currentClient.quote &&( currentClient.quote.status === 1 || currentClient.quote.status === 2)"
            class="additionalPadding"
        >
          <div
              class="clientDetails__message"
              :class="[currentClient.quote.status === 1 ? '' : 'error']"
          >
            <div class="clientDetails__message__triangle"></div>
            <div class="clientDetails__message__date">{{ currentClient.quote.updated_at }}</div>
            <div
                class="clientDetails__message__msg"
            >{{ currentClient.quote.status === 1 ? $t('clientDetails.clientAcceptedYourProposal') : $t('clientDetails.clientDidntAcceptYourProposal')}}
            </div>
          </div>
          <div v-if="chosenBattery">
            <div v-if="chosenBattery.manufacturer" class="clientDetailsRow">
              <span class="clientDetailsRow__text">{{$t('clientDetails.brand')}}</span>
              <span class="clientDetailsRow__text">{{ chosenBattery.manufacturer }}</span>
            </div>
            <div v-if="chosenBattery.model" class="clientDetailsRow">
              <span class="clientDetailsRow__text">{{$t('report.model')}}</span>
              <span class="clientDetailsRow__text">{{ chosenBattery.model }}</span>
            </div>
            <div v-if="chosenBattery.part" class="clientDetailsRow">
              <span class="clientDetailsRow__text">{{$t('report.part')}}</span>
              <span class="clientDetailsRow__text">{{ chosenBattery.part }}</span>
            </div>
            <div
                v-if="chosenBattery.parameters && chosenBattery.parameters.cca"
                class="clientDetailsRow"
            >
              <span class="clientDetailsRow__text">{{$t('report.cca')}}</span>
              <span class="clientDetailsRow__text">{{ chosenBattery.parameters.cca + ' Ah' }}</span>
            </div>
            <div
                v-if="chosenBattery.parameters && chosenBattery.parameters.capacity"
                class="clientDetailsRow"
            >
              <span class="clientDetailsRow__text">{{$t('report.capacity')}}</span>
              <span class="clientDetailsRow__text">{{ chosenBattery.parameters.capacity }}</span>
            </div>
            <div
                v-if="chosenBattery.battery_price >= 0 && chosenBattery.service_price >= 0"
                class="clientDetailsRow"
            >
              <span class="clientDetailsRow__text">{{$t('report.price')}}</span>
              <span
                  class="clientDetailsRow__text"
              >{{ 'Total ' + getTotalPrice(chosenBattery.battery_price,chosenBattery.service_price ) }}{{currentClient.currency.label}}</span>
            </div>

            <div class="clientDetailsRow__comment mb-3" v-if="chosenBattery.comment">
              <h3 class="text-center mt-2 mb-1">{{$t('clientDetails.comment')}}:</h3>
              <div class="pl-3 pr-3">
                <i>
                  <span class="clientDetailsRow__comment__text">{{chosenBattery.comment}}</span>
                </i>
              </div>
            </div>
            <!--
            <div v-if="chosenBattery.comment" class="clientDetailsRow">
              <span class="clientDetailsRow__text">{{chosenBattery.comment}}</span>
            </div>-->
          </div>
        </div>
        <h4 v-if="vehicle" class="form-title mb-3">{{$t('clientDetails.carDetails')}}</h4>
        <div v-if="vehicle" class="additionalPadding">
          <div v-if="vehicle.name" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('clientDetails.car')}}&nbsp;</span>
            <span class="clientDetailsRow__text text-right">{{vehicle.name}}</span>
          </div>
          <div v-if="vehicle.plates || vehicle.vin" class="clientDetailsRow mb-5">
            <span
                class="clientDetailsRow__text"
            >{{vehicle.plates ? $t('general.plates') : vehicle.vin ? $t('general.vin') : ''}}</span>
            <span
                class="clientDetailsRow__text"
            >{{vehicle.plates ? vehicle.plates : vehicle.vin ? vehicle.vin : ''}}</span>
          </div>
        </div>
        <h4 class="form-title mb-3">{{$t('clientDetails.clientContact')}}</h4>
        <div class="additionalPadding">
          <div v-if="currentClient.first_name" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('general.name')}}</span>
            <span class="clientDetailsRow__text">{{ currentClient.first_name}}</span>
          </div>
          <div v-if="currentClient.last_name" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('general.surname')}}</span>
            <span class="clientDetailsRow__text">{{ currentClient.last_name}}</span>
          </div>
          <div v-if="currentClient.telephone" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('general.telephone')}}</span>
            <span class="clientDetailsRow__text">{{ currentClient.telephone}}</span>
          </div>
          <div v-if="currentClient.email" class="clientDetailsRow mb-5">
            <span class="clientDetailsRow__text">{{$t('general.email')}}</span>
            <span class="clientDetailsRow__text">{{ currentClient.email}}</span>
          </div>
        </div>
        <div class="battery-test-result" v-if="batteryTestResult">
          <h4 class="form-title mb-3">{{$t('clientDetails.batteryTestResult')}}</h4>
          <div class="additionalPadding">
            <div class="clientDetailsRowTwo">
              <div class="report__resultRow">
                <font-awesome-icon
                    class="green-icon"
                    :icon="['fas', true ? 'check-circle' : 'times-circle bad']"
                />
                {{$t('testResult.rated')}}
                <span
                    class
                >{{batteryTestResult['cca_rated']}} {{$t('general.cca')}}</span>
              </div>
            </div>
            <div class="clientDetailsRowTwo">
              <VoltageResultComponent :voltage="batteryTestResult.voltage"/>
            </div>
            <div class="clientDetailsRowTwo">
              <CcaMeasured
                  :ccaMeasured="batteryTestResult['cca_measured']"
                  :overallResult="batteryTestResult['overall_result']"
              />
            </div>
            <div class="clientDetailsRowTwo">
              <TemperatureResult :battery-temperature="batteryTestResult['temperature_measured']"/>
            </div>
            <div class="clientDetailsRowTwo">
              <CrankingAndReservedResults :current-test-result="batteryTestResult" from="report"/>
            </div>

            <h2 class="text-center">{{$t('clientDetails.diagnosis')}}</h2>

            <div class="clientDetailsRowTwo mb-4" style="padding-bottom: 10px">
              <GeneralDiagnosis :overall-result="batteryTestResult['overall_result']"/>
            </div>
          </div>
        </div>

        <h4 v-if="currentClient && currentClient.driving_pattern_message "
            class="form-title mb-3"
        >{{$t('general.drivingPattern')}}</h4>
        <div
            v-if="currentClient && currentClient.driving_pattern_message"
            class="additionalPadding"
        >
          <div v-if="currentClient.driving_pattern.trips" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('clientDetails.tripsDay')}}</span>
            <span class="clientDetailsRow__text">{{ currentClient.driving_pattern.trips }}</span>
          </div>
          <div v-if="currentClient.driving_pattern.distance" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('clientDetails.kmDay')}}</span>
            <span class="clientDetailsRow__text">{{currentClient.driving_pattern.distance}}</span>
          </div>
          <div v-if="currentClient.driving_pattern.capacity" class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('otherBattery.capacityAh')}}</span>
            <span class="clientDetailsRow__text">{{currentClient.driving_pattern.capacity}}</span>
          </div>
          <div class="clientDetailsRow">
            <DrivingPatternBar
                :result="currentClient.driving_pattern_result"
                :message="currentClient.driving_pattern_message"
            ></DrivingPatternBar>
          </div>
          <div class="clientDetailsRow">
            <span class="clientDetailsRow__text">{{$t('smsStatus.drivingPatternSmsStatus')}}</span>
            <span class="clientDetailsRow__text">
              <template v-if="drivingPatternSmsHash">{{ smsStatusTranslation(drivingPatternSmsStatus) }}</template>
              <template v-else>{{ smsStatusTranslation(currentClient.driving_pattern.sms_status) }}</template>
            </span>
          </div>

          <div class="clientDetailsRow mb-2">
            <button class="btn btn-primary btn-block mb-2" @click.prevent="sendDrivingPatternSMS">{{$t('smsStatus.sendAgain')}}</button>
          </div>

        </div>
      </div>
    </div>
    <bottom-navigation></bottom-navigation>
  </fragment>
</template>

<script>
  import {mapGetters} from 'vuex';
  import DefaultHeader from '@/partials/DefaultHeader';
  import BottomNavigation from '@/partials/BottomNavigation';
  import {HTTP} from '../http';
  import BackBtn from '../components/BackBtn';
  import DrivingPatternBar from '../components/DrivingPatternBar';
  import VoltageResultComponent from '../components/VoltageResultComponent';
  import TemperatureResult from '../components/TemperatureResult';
  import CcaMeasured from '../components/CcaMeasured';
  import CrankingAndReservedResults from '../components/CrankingAndReservedResults';
  import GeneralDiagnosis from '../components/GeneralDiagnosis';
  import PhoneNumberModal from "../components/PhoneNumberModal";

  export default {
    name: 'ClientDetails',
    components: {
      CrankingAndReservedResults,
      CcaMeasured,
      TemperatureResult,
      VoltageResultComponent,
      DefaultHeader,
      BottomNavigation,
      BackBtn,
      DrivingPatternBar,
      GeneralDiagnosis,
      PhoneNumberModal
    },
    data() {
      return {
        currentClient: null,
        currentVehicle: null,
        currentClientLoadingStatus: true,
        vehicle: null,
        chosenBattery: null,
        batteryTestResult: null,
        showPhoneNumberModal: false,
        phoneNumberModalContext: null,
        smsStatus: {},
        drivingPatternSmsHash: null,
        quoteSmsHash: null,
        drivingPatternSmsStatus: null,
        quoteSmsStatus: null
      };
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      })
    },
    beforeMount() {
      const activeClientID = localStorage.getItem('exideActiveClientID');
      if (activeClientID) {
        this.currentClientLoadingStatus = true;
        HTTP.get(`/api/client/${activeClientID}`)
          .then(res => {
            this.currentClientLoadingStatus = false;
            this.currentClient = res.data;
            this.vehicle = res.data.vehicle_data;
            this.batteryTestResult = this.currentClient['battery_tests_results'];

            if (this.currentClient.quote) {
              if (this.currentClient.quote.status === 1) {
                this.findChosenBattery(this.currentClient.quote.batteries);
              }
              if (this.currentClient.quote.sms_hash) {
                this.quoteSmsHash = this.currentClient.quote.sms_hash;
                this.$set(this.smsStatus, this.currentClient.quote.sms_hash, this.currentClient.quote.sms_status);

                if (this.currentClient.quote.sms_status !== 'delivered') {
                  this.checkSmsStatus(this.currentClient.quote.sms_hash, 1);
                }
              }
            }

            if (this.currentClient.driving_pattern && this.currentClient.driving_pattern.sms_hash) {
              this.quoteSmsHash = this.currentClient.driving_pattern.sms_hash;
              this.$set(this.smsStatus, this.currentClient.driving_pattern.sms_hash, this.currentClient.driving_pattern.sms_status);

              if (this.currentClient.driving_pattern.sms_status !== 'delivered') {
                this.checkSmsStatus(this.currentClient.driving_pattern.sms_hash, 1);
              }
            }

            if (this.batteryTestResult && this.batteryTestResult.overall_result == null) {
              this.batteryTestResult.overall_result = this.parseResult(
                this.batteryTestResult.test_result
              );
            }
          })
          .catch(err => {
            this.currentClientLoadingStatus = false;
            this.$router.push({name: 'ClientsList'});
          });
      } else {
        this.$router.push({name: 'ClientsList'});
      }
    },
    mounted() {
      $('.paddingToHide').css('padding-left', '0px');
      $('.paddingToHide').css('padding-right', '0px');

    },
    destroyed() {
      $('.paddingToHide').css('padding-right', '15px');
      $('.paddingToHide').css('padding-left', '15px');
    },
    methods: {
      parseResult(result) {
        let valuesMap = [
          {
            value: 2,
            array: ['00', '-0']
          },
          {
            value: 1,
            array: ['01', '-1']
          },
          {
            value: 0,
            array: ['05', '-5', '06', '-6']
          }
        ];

        for (const index in valuesMap) {
          if (valuesMap[index].array.includes(result)) {
            return valuesMap[index].value;
          }
        }

        return 0;
      },

      findChosenBattery(batteries) {
        for (let i = 0; i < batteries.length; i++) {
          if (batteries[i].chosen === 1) {
            this.chosenBattery = batteries[i];
          }
        }
      },

      getTotalPrice(priceOne, priceTwo) {
        return Number(priceOne) + Number(priceTwo);
      },

      resendSms(phone) {
        this.showPhoneNumberModal = false;
        HTTP.patch(`/api/clients-phone-number/${this.currentClient.id}`, {
          phone_number: phone
        }).then(() => {
          if (this.phoneNumberModalContext === 'driving_pattern') {
            this.sendDrivingPatternSMS()
          }
          if (this.phoneNumberModalContext === 'quote') {
            this.sendQuote()
          }
        }).catch(() => {
          this.$toasted.show(this.$i18n.t('testResult.somethingWrong'));
        });
      },

      sendQuote() {
        HTTP.post('/api/quote', {
          client_id: this.currentClient.id,
          battery_tests_result_id: this.batteryTestResult.id,
          batteries: this.currentClient.quote.batteries,
          force_sms: true
        })
          .then(res => {
            if (res.data.hasOwnProperty('hash')) {
              let hash = res.data.hash;
              this.$toasted.show('Sending SMS...', {
                duration: null,
                className: 'success',
                onComplete: () => {
                  this.$set(this.smsStatus, hash, 'hidden');
                },
                action: [
                  {
                    text: 'Hide',
                    onClick: (e, toastObject) => {
                      this.$set(this.smsStatus, hash, 'hidden');
                      toastObject.goAway(0);
                      toastObject.goAway(0);
                    }
                  },
                ]
              });
              this.quoteSmsHash = hash;
              this.checkSmsStatus(hash, 1);
            }
          })
          .catch(err => {
            if (err && err.hasOwnProperty('response')) {
              if (err.response.data.smsError) {
                if (err.response.data.smsError && err.response.data.smsErrorType == 'invalid_number') {
                  this.$toasted.clear();
                  this.phoneNumberModalContext = 'quote';
                  this.showPhoneNumberModal = true;
                } else {
                  this.$toasted.show(this.$i18n.t('testResult.somethingWrong'));
                }
              }
            } else {
              this.$toasted.show(this.$i18n.t('quote.somethingWrong'));
            }
          });
      },

      sendDrivingPatternSMS() {
        HTTP.post('/api/driving-pattern-sms', {
          client_id: this.currentClient.id,
          result_id: this.batteryTestResult.id,
        })
          .then(response => {
            if (!response.error) {
              this.$toasted.show(this.$t('testResult.drivingPatternAnalyzeWasSend'), {
                className: 'success'
              });

              this.drivingPatternSmsHash = response.data.hash;
              this.checkSmsStatus(response.data.hash, 1);
            }
          })
          .catch(err => {
            if (err.response.data.errorType == 'invalid_number') {
              this.$toasted.clear();
              this.showPhoneNumberModal = true;
              this.phoneNumberModalContext = 'driving_pattern'
            } else {
              this.$toasted.show(this.$i18n.t('testResult.somethingWrong'));
            }
          });
      },

      checkSmsStatus(hash, counter) {
        HTTP.post('/api/check-sms-status', {
          'hash': hash
        }).then(response => {
          if (this.smsStatus[hash] === 'hidden') {
            return;
          }

          if (!response.data.hasOwnProperty('status') || ['failed', 'undelivered', 'pre_failed'].includes(response.data.status)) {
            this.$set(this.smsStatus, hash, 'failed');
            this.$toasted.clear();
            this.$toasted.show(this.$i18n.t('smsStatus.sendingFailedModalMessage'));
            return;
          }

          if (['delivered', 'received'].includes(response.data.status)) {
            this.$set(this.smsStatus, hash, 'delivered');
            this.$toasted.clear();
            this.$toasted.show(this.$i18n.t('smsStatus.deliveredModalMessage'), {
              className: 'success',
            });
          }

          if (counter < 20 && ['sent', 'accepted', 'queued', 'sending', 'receiving', 'received', null].includes(response.data.status)) {
            counter++;
            setTimeout(() => {
              this.$set(this.smsStatus, hash, 'sending');
              this.checkSmsStatus(hash, counter)
            }, 3000);
          }
        }).catch(err => {
          this.$set(this.smsStatus, hash, 'failed');
        });
      },


      closeModal() {
        this.showPhoneNumberModal = false;
      },
      smsStatusTranslation(status) {
        if (status == 'delivered') {
          return this.$i18n.t('smsStatus.delivered');
        }
        if (status == 'sent') {
          return this.$i18n.t('smsStatus.sent');
        }
        if (status == 'not_sent') {
          return this.$i18n.t('smsStatus.notSent');
        }
        if (status == 'sending') {
          return this.$i18n.t('smsStatus.sending');
        }
        if (status == 'failed') {
          return this.$i18n.t('smsStatus.failed');
        }
        if (status == 'pre_failed') {
          return this.$i18n.t('smsStatus.failed');
        }
        return '';
      },

    },
    watch: {
      smsStatus: {
        deep: true,
        handler: function (newVal) {
          this.drivingPatternSmsStatus = this.smsStatus[this.drivingPatternSmsHash]
          this.quoteSmsStatus = this.smsStatus[this.quoteSmsHash]

        }
      }
    }
  };
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.clientDetailsRow {
  display: flex;
  justify-content: space-between;
  padding: 14px 20px 10px;
  border-bottom: 1px solid $gray-light;

  &__text {
    font-weight: 500;
    color: $black;
  }

  &__comment {
    &__text {
      font-size: 14px;
    }
  }
}

.clientDetailsRowTwo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 14px 20px 10px;
}

svg {
  margin-right: 15px;
}

.red-icon {
  color: $red;
}

.green-icon {
  color: $green;
}

.clientDetails {
  &__message {
    height: 64px;
    width: calc(100% - 15px);
    background: $primary;
    border-radius: 5px;
    margin-left: 12px;
    position: relative;
    color: white;
    padding: 15px 20px;
    margin-bottom: 1rem;

    &__triangle {
      position: absolute;
      width: 0;
      height: 0;
      border-top: 15px solid transparent;
      border-right: 15px solid $primary;
      border-bottom: 0px solid transparent;
      left: -10px;
      bottom: 9px;
    }

    &__date {
      font-weight: 300;
      font-size: 10px;
      line-height: 140%;
    }

    &__msg {
      font-weight: 300;
      font-size: 14px;
      line-height: 140%;
    }

    &.error {
      background: $gray-light;
      border: 1px solid $red;
      color: $black;

      .clientDetails__message__triangle {
        display: none;
      }
    }
  }
}
</style>
